/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for check admin permission for a healthpro planning
 * @export
 * @interface CheckAdminPlanningPermissionResponse
 */
export interface CheckAdminPlanningPermissionResponse {
    /**
     * True if the current person is allowed to admin a planning
     * @type {boolean}
     * @memberof CheckAdminPlanningPermissionResponse
     */
    allowed?: boolean;
}

/**
 * Check if a given object implements the CheckAdminPlanningPermissionResponse interface.
 */
export function instanceOfCheckAdminPlanningPermissionResponse(value: object): value is CheckAdminPlanningPermissionResponse {
    return true;
}

export function CheckAdminPlanningPermissionResponseFromJSON(json: any): CheckAdminPlanningPermissionResponse {
    return CheckAdminPlanningPermissionResponseFromJSONTyped(json, false);
}

export function CheckAdminPlanningPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckAdminPlanningPermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'] == null ? undefined : json['allowed'],
    };
}

export function CheckAdminPlanningPermissionResponseToJSON(json: any): CheckAdminPlanningPermissionResponse {
    return CheckAdminPlanningPermissionResponseToJSONTyped(json, false);
}

export function CheckAdminPlanningPermissionResponseToJSONTyped(value?: CheckAdminPlanningPermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
    };
}

